import { useDisclosure } from '@nextui-org/react'
import { FC } from 'react'
import { useGrade } from '../../hooks/useGrade'
import useHomeGradeStore from '../../store/home/useHomeGradeStore'
import { CommonAlert } from '../common/Alert'
import { BaseModalFooter } from '../common/Modal'

type InitialInfoButtonProps = {
  onClose: () => void
  isBack: () => void
}
export const InitialInfoButton: FC<InitialInfoButtonProps> = ({ onClose, isBack }) => {
  const {
    setTanksInfoBorderColor,
    tanksValues,
    depCount,
    sumCount,
    sendGradeData,
    gradeDate,
    departureSchoolId,
    typeError,
  } = useHomeGradeStore()
  const { isOpen: isOpenAlert, onOpen: onOpenAlert, onClose: onCloseAlert } = useDisclosure()
  const gradeMutation = useGrade()

  const chekTanksValuesBeforeFinish = () => {
    setTanksInfoBorderColor()
    if (tanksValues.every((item) => item.count !== null && item.count > 0) && !typeError) {
      if (depCount !== sumCount && sendGradeData) {
        onOpenAlert()
      } else if (sendGradeData) {
        finishJob(onClose)
      }
    }
  }

  const finishJob = (onCloseModal: () => void, _onOpen?: () => void) => {
    if (sendGradeData && departureSchoolId && gradeDate) {
      gradeMutation.mutate(
        { gradeDate, gradeData: sendGradeData, departureId: departureSchoolId },
        {
          onSuccess: () => {
            onCloseModal()
          },
        },
      )
    }
  }

  return (
    <>
      <BaseModalFooter
        back="Back"
        next="Finish"
        backOnPress={() => {
          onClose()
          isBack()
        }}
        nextOnPress={chekTanksValuesBeforeFinish}
      />
      <CommonAlert
        key="CountsNotEqualAlert"
        isOpenAlert={isOpenAlert}
        onCloseAlert={onCloseAlert}
        continueJob={(_, __) => finishJob(onClose, undefined)}
        title="The Count doesn't match!"
      >
        <p>{`The sum of the counts, ${sumCount}, does not match the departure tank's count of ${depCount}. Do you want to continue grading?`}</p>
      </CommonAlert>
    </>
  )
}
